var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('v-container',[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('h1',{staticClass:"display-4"},[_vm._v("404")]),_c('h2',{staticClass:"display-2 grey--text"},[_vm._v("Not Found")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }